<div class="quick-quote-container" dclClickOutside (clickOutside)="closeWrapper($event)">
    <dcl-quick-quote-bar
        [isOpen]="isOpen"
        [isMobile]="isMobile"
        [filterOptions]="filterData"
        [hideViewCruisesButton]="hideViewCruisesButton"
        (onApplyFilters)="onApplyFilters()"
        (onFilterSelected)="openFilter($event)">
    </dcl-quick-quote-bar>
    <div class="mobile" *ngIf="isModalOpen">
        <dcl-quick-quote-modal
            [isDclAdvancedBooking]="isDclAdvancedBooking"
            [filtersData]="filterData"
            [filterDataSubGroup]="filterDataSubGroup"
            (onApplyFilters)="onApplyFilters($event)"
            (onClearFilters)="onClearFilters()"
            (onCloseModal)="onCloseModal($event)"
            [open]="isModalOpen">
        </dcl-quick-quote-modal>
    </div>
    <div class="desktop">
        <dcl-quick-quote-filter-wrapper
            *ngIf="isOpen"
            (onApplyFilters)="onApplyFilters($event)"
            [isDclAdvancedBooking]="isDclAdvancedBooking"
            [filterData]="filterData[filterSelectedIndex]"
            [filterDataSubGroup]="filterDataSubGroup"
            [showClearBtn]="constants.filters['travel-party'].id !== filterData[filterSelectedIndex]?.type">
        </dcl-quick-quote-filter-wrapper>
    </div>
</div>
